import { AxiosProgressEvent } from 'axios';

import {
  IAssignmentQuestion,
  IAssignmentSubmission,
  ICourseAssignment,
  IQuestionAnswerAttachment,
  IStartAssignmentResponse,
  ISubmitQuestionAnswerRequest,
} from '../types/assignmentTypes';
import API from './';

export default abstract class AssignmentAPI {
  static root = '/api/v1/assignment';

  static getAssignmentDetails = (assignmentId: string) => {
    return API.get<ICourseAssignment>(`${this.root}/details/${assignmentId}`);
  };

  /**
   * Get all questions in an assignment (code = 200)
   */
  static getAllQuestionsInAssignment = (assignmentId: string) => {
    return API.get<IAssignmentQuestion[]>(
      `${this.root}/${assignmentId}/preview-questions`,
    );
  };

  static getAssignmentQuestion = (assignmentId: string, questionId: string) => {
    return API.get<IAssignmentQuestion>(
      `${this.root}/${assignmentId}/questions/${questionId}`,
    );
  };

  static uploadAssignmentQuestionAttachments = (
    assignmentId: string,
    questionId: string,
    data: FormData,
    onUploadProgress?: (event: AxiosProgressEvent) => void,
  ) => {
    return API.post<IQuestionAnswerAttachment[]>(
      `${this.root}/${assignmentId}/questions/${questionId}/attachments`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        onUploadProgress,
      },
    );
  };

  static assignmentAction = (
    assignmentId: string,
    action: 'start' | 'resume' | 'retake' | 'end',
  ) => {
    return API.post<IStartAssignmentResponse>(
      `${this.root}/${assignmentId}/actions/${action}`,
    );
  };

  static submitAssignmentAnswer = (
    assignmentId: string,
    questionId: string,
    action: 'submit' | 'clear' | 'save',
    data: ISubmitQuestionAnswerRequest,
  ) => {
    return API.post<IAssignmentSubmission>(
      `${this.root}/${assignmentId}/questions/${questionId}/answer/${action}`,
      data,
    );
  };

  static getAssignmentSubmissionReview = (
    assignmentId: string,
    userId: string,
  ) => {
    return API.get<IAssignmentSubmission>(
      `${this.root}/${assignmentId}/review/${userId}`,
    );
  };
}
